const pattern = /{photoset:({.+}|(?:[^;}];?)+)}/;

export default pattern;